let splideInstance;

function initSlider() {
  if (window.innerWidth <= 1023) {
    if (!splideInstance) {
      splideInstance = new Splide('.sattu-slider', {
        perPage: 2,
        gap: '10px',
        arrows: false,
        pagination: true,
        breakpoints: {
          768: {
            perPage: 1.2,
          },
        },
      }).mount();
    }
  } else {
    if (splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', initSlider);
window.addEventListener('resize', initSlider);